export default __webpack_public_path__ + "static/gs-a193265c7b547240dd9ec17b17b5592a.svg";